module.exports = __webpack_public_path__ + "img/file-upload1.caabce74.png";